<template>

    <div class="container">
    <Row>
      <Col span="24" offset="-1" style="background: white;height: 450px;box-shadow: 0.5px 0.5px 3px 0.5px darkgray" >
      <br>
      <br>
     <Col span="10" offset="1" v-if="projectPictureRows!=null && projectPictureRows.length>0">
        <Carousel autoplay loop>
            <CarouselItem v-for="(item,index) in projectPictureRows" :key="index">
            <img :src="item.imgPath" width="100%" />
            </CarouselItem>
        </Carousel>
      </Col>
      <Col span="10" offset="1" v-if="projectPictureRows==null || projectPictureRows.length==0">
        <img :src="img4" width="100%" height="400px">
      </col>
      <Col span="10" offset="1"  align="left" >
      <Col span="24" style="font-size: 24px;line-height:25px;">
      {{project.projectTitle}}
      </Col>
      <Col span="2"> 
	        <div @click="addCollection()"> <template v-if="2==icon"><Icon type="md-star" size='25' style="color:orange"/></template>
          <template v-if="1==icon"><Icon type="md-star-outline"  size='25' style="color:orange" /></template></div>
       </Col>
      <br/>
      <br/>
      <Col span="10" style="font-size: 14px; ">
      拟募集资金金额:<span style="color:red;font-size: 18px;">{{project.money}}</span>万元
      </Col>
      
      <Col span="10" offset="3" style="font-size: 14px; ">所在地：{{project.projectProvince}}
      </Col> 
   
      <br/>
      <br/>
       
      <Col span="10"  style="font-size: 14px; " >
      信息披露期：<span style="color:orange;">{{project.infoDisclosePeriod}}</span>
      </Col>
     
      <Col span="11" offset="3" style="font-size: 14px; ">所属行业：{{project.industry}}
      </Col>  
      
      <br/>
      <br/>
      <Col  span="10" style="font-size: 14px; " >
      保证金：<span style="color:red;">{{project.payDeposit}}</span>
      </Col>
     
      <Col span="10" offset="3" style="font-size: 14px; ">
      经济性质：{{project.economicNature}}
      </Col>
       <br>
      <br>

      <Col offset="5" span="10" style="background: orange; font-size: 25px; ">
      <Icon type="md-call" />
      {{project.phone}}4006-010-661
      </Col>
       <br/>
      <br/>
       <br/>
      <Col>
      <Col  span="15" style="line-height:25px;font-size: 14px; ">
      信息披露开始时间：{{project.infoDiscloseStart}}<br><br>
      信息披露结束时间：{{project.infoDiscloseEnd}}<br>
      </Col>
      </Col>
      <br>
       <br>
       <br>
      <Col span="24" offset="0" style="border: 1px solid ;border-color: lightgray;background: #f6f6f6;line-height:25px;font-size: 14px;">
        {{projectTxt.projectOutline}}
      </Col>
      </Col>
      </Col>
    </Row>
    <br/>
       <!--<Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="4" class="info" v-for="(item,index) in info" :key="index">{{item}}</Col>
        </Col>
       </Row>-->
       <Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="6" class="info" ><a href="#1" style="font-size:18px;color:black;">项目基本信息</a></Col>
        <Col span="6" class="info" ><a href="#2" style="font-size:18px;color:black;">经营信息</a></Col>
        <Col span="6" class="info" ><a href="#3" style="font-size:18px;color:black;">企业资质</a></Col>
        <Col span="6" class="info" ><a href="#4" style="font-size:18px;color:black;">其他</a></Col>
        </Col>
       </Row>
       <br/>
    <Row id="1">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;overflow:hidden;">
      <Col span="3" offset="1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">项目基本信息</span>
      
      </Col>
      <Divider />

      <Col offset="1" span="22">
      <table width="100%" height="500px" >
        <tr>
          <td>融资类型</td><td colspan="3">{{projectFinancing.financingType}}</td>
        </tr>
        <tr>
          <td>拟融资金额</td><td >{{projectFinancing.financingAmount}}</td>  <td>融资期限</td><td >{{projectFinancing.financingPeriod}}</td>
        </tr>
        <tr>
          <td>可接受的融资利率（年化）</td><td>{{projectFinancing.financingRate}}</td><td>资金用途</td><td>{{projectFinancing.moneyPurpose}}</td>
        </tr>
        <tr>
          <td>担保方式</td><td colspan="3">{{projectFinancing.guaranteeMode}}</td>
        </tr>
        <tr>
          <td>还款来源</td><td colspan="3">{{projectFinancing.payment}}</td>
        </tr>
        <tr>
          <td>统一社会信用代码</td><td colspan="3"> {{projectInfo.unifiedCode}}</td>
        </tr> 
        <tr>
          <td>企业性质</td><td>{{projectInfo.companyType}}</td><td>注册资本</td><td>{{projectInfo.registeredCapital}}</td>
        </tr> 
        <tr>
          <td>成立时间</td><td>{{projectInfo.establishmentDate}}</td><td>法定代表人</td><td>{{projectInfo.legalPerson}}</td>
        </tr> 
        <tr>
          <td>公司注册地址</td><td colspan="3">{{projectInfo.registeredAddress}}</td>
        </tr> 
        <tr>
          <td>公司经营地址</td><td colspan="3">{{projectInfo.businessAddress}}</td>
        </tr>
        <tr>
          <td>经营范围</td><td  colspan="3">{{projectTxt.businessScope}}</td>
        </tr>
       <tr style="backgrond:white;">
        <td colspan="4" >标的企股权结构  </td>
      </tr>
      <tr>
        <td>前10位股东名称</td><td colspan="3">持股比例</td></tr>
      <tr>
        <td>公司简介</td><td colspan="3">{{projectTxt.projectOutline}}</td></tr>
      <tr>
        <td>项目名称</td><td colspan="3">{{projectInfo.projectName}}</td></tr>
      <tr>
        <td colspan="4">联系方式</td></tr>
      <tr>
        <td>联系人</td><td>{{projectContacts.linkman}}</td><td>联系电话</td><td>{{projectContacts.phone}}</td></tr>
      <tr>
        <td>邮箱地址</td><td colspan="3">{{projectContacts.email}}</td></tr>
      </table>
      <br>
      <br>
      </Col>
      </Col>
    </Row>
    <br/>
    <Row id="2">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray; ">
       <Col span="2" offset="1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">经营信息</span>
      
      </Col>
       <Divider />
      <Col offset="1" span="22">
     <table width="100%" >
       <tr><td colspan="7">最近一期的财务数据</td></tr>
          <tr><td>年度</td><td>{{finance.year}}</td><td>总资产</td><td></td><td>总负责</td><td></td></tr>
          <tr><td>所有者权益</td><td></td><td>营业收入</td><td></td><td>总利润</td><td></td></tr>
       
         <tr><td colspan="7">最近三年的审计报告</td></tr>
          <tr><td>年度</td><td></td><td>总资产</td><td></td><td>总负责</td><td></td></tr>
          <tr><td>所有者权益</td><td></td><td>营业收入</td><td></td><td>总利润</td><td></td></tr>
          <tr><td>年度</td><td></td><td>总资产</td><td></td><td>总负责</td><td></td></tr>
          <tr><td>所有者权益</td><td></td><td>营业收入</td><td></td><td>总利润</td><td></td></tr>
          <tr><td>年度</td><td></td><td>总资产</td><td></td><td>总负责</td><td></td></tr>
          <tr><td>所有者权益</td><td></td><td>营业收入</td><td></td><td>总利润</td><td></td></tr>
     </table>
     <br>
      <br>
      </col>
      </Col>
        </Row>
          <br/>
    <Row  id="3">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="2" offset="1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">企业资质</span>
      </col>
       <Divider />
       <Col span="22" offset="1" >
       <table width="100%" height="210px">
         <tr><td style="width:150px">团队介绍</td><td style="width:450px;">{{projectTxt.transferorPromise}}</td></tr>
         <tr><td>认证情况</td><td>{{projectTxt.transfer}}</td></tr>
         <tr><td>荣誉情况</td><td>{{projectTxt.companySubsist}}</td></tr>
          <tr><td>专利情况</td><td>{{projectTxt.debtDisposal}}</td></tr>
           <br>
           <br> 
       </table>
       <br><br>
       </Col>
      </Col>
      </Row>
       <br/>
    <Row  id="4">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;overflow:hidden;">
      <Col span="1" offset="1" style="font-size: 23px">
      <span style="border-bottom:3px solid orange;font-family: 黑体">其他</span>
      </col>
        <Divider />
        <Col span="22" offset="1">
        <table width="100%" height="100px">
          <tr><td style="width:30%">采集源地址</td><td style="width:70%;">{{collectAddress[0].attrValue}}</td></tr>
          <tr><td>下载</td><td>
            <span v-for="item in projectAttachmentRows"><a :href="item.attachmentPath">{{item.attachmentName}}</a></span>
            </td></tr>
        </table>
        <br><br>
        </Col>
      </Col>
      </Row>
    </div>

</template>

<script>
  /*  import itable from "./components/table"; */

    export default {
   /*  components: {itable}, */
      data(){
        return{
          project: [],
          projectInfo: [],
          projectTxt: [],
          projectFinancing:[],
          projectContacts:[],
          img4:"../../../static/noImg.png",
          Enclosure:[],
          projectPictureRows:[],
          projectAttachmentRows:[],
          projectFinance:[],
          projectShareholderRows:[],
          //最近一年财务报告
          finance:{
            year              :"", //string	100	年度
            totalAssets	      :"", //string	100	资产总计（万元）
            totalLiabilities	:"", //string	100	负债总计（万元）
            ownerEquity      	:"", //string	100	所有者权益（万元）
            businessIncome	  :"", //string	100	营业收入（万元）
            operatingProfit	  :"", //string	100	营业利润（万元）
            projectId	        :"", //string		项目id（支持多个）
            type              :"F02", //int		类型 审计报告/财务报告
            priority        	:"1", //string	100	排序
          },
          //近年审计报告
          auditFirst:{
            year              :"", //string	100	年度
            totalAssets	      :"", //string	100	资产总计（万元）
            totalLiabilities	:"", //string	100	负债总计（万元）
            ownerEquity      	:"", //string	100	所有者权益（万元）
            businessIncome	  :"", //string	100	营业收入（万元）
            operatingProfit	  :"", //string	100	营业利润（万元）
            projectId	        :"", //string		项目id（支持多个）
            type              :"F01", //int		类型 审计报告/财务报告
            priority        	:"1", //string	100	排序
          },
          auditSecond:{
            year              :"", //string	100	年度
            totalAssets	      :"", //string	100	资产总计（万元）
            totalLiabilities	:"", //string	100	负债总计（万元）
            ownerEquity      	:"", //string	100	所有者权益（万元）
            businessIncome	  :"", //string	100	营业收入（万元）
            operatingProfit	  :"", //string	100	营业利润（万元）
            projectId	        :"", //string		项目id（支持多个）
            type              :"F01", //int		类型 审计报告/财务报告
            priority        	:"2", //string	100	排序
          },
          auditThird:{
            year              :"", //string	100	年度
            totalAssets	      :"", //string	100	资产总计（万元）
            totalLiabilities	:"", //string	100	负债总计（万元）
            ownerEquity      	:"", //string	100	所有者权益（万元）
            businessIncome	  :"", //string	100	营业收入（万元）
            operatingProfit	  :"", //string	100	营业利润（万元）
            projectId	        :"", //string		项目id（支持多个）
            type              :"F01", //int		类型 审计报告/财务报告
            priority        	:"3", //string	100	排序
          },
          collectAddress:[{attrName:'采集源地址',attrValue:''}],
          info:['基本信息','企业信息','企业资质','相关附件']
      
        
        }
      },
      mounted(){
         this.getProject();
      },
      methods:{
      getProject:function(){
        let that=this;
        protocol.param_projectDetail.data.projectId=this.$route.query.detailId;      
        http.gets(protocol.param_projectDetail,protocol.param_projectDetail.data).then(response => {
                let {msg,code,project,projectInfo,projectShareholderRows,projectFinanceRows,projectPrerequisites,projectTransfer,
                  projectTxt,projectPicture,projectFinancing,projectContacts,projectAttrRows,projectPictureRows,projectAttachmentRows} = response.data;
                console.log(msg);
        if (code === 0) {

            if(project!=null){
              this.project = project;
            }
            if(projectInfo!=null){
                this.projectInfo = projectInfo;
            }
            if(projectTxt!=null){
                this.projectTxt = projectTxt;
            }
            if(projectFinancing!=null){
                this.projectFinancing = projectFinancing;
            }
            if(projectContacts!=null){
                this.projectContacts = projectContacts;
            }
            //股权结构
          for(let value of projectShareholderRows){
              let obj = {};
              obj.id= value.id;
            
              obj.shareholderName = value.shareholderName;
              obj.proportion = value.proportion;
              obj.priority = value.priority;
            
              this.projectShareholderRows.push(obj);
          }
          //财务信息
          this.finance      = {}
          this.auditFirst   = {}
          this.auditSecond  = {}
          this.auditThird   = {}
          for(let item in projectFinanceRows){
            if(projectFinanceRows[item].type == 'F01'){
              if(projectFinanceRows[item].priority == '1'){
                this.auditFirst   = projectFinanceRows[item]
              }else if(projectFinanceRows[item].priority == '2'){
                this.auditSecond   = projectFinanceRows[item]
              }else if(projectFinanceRows[item].priority == '3'){
                this.auditThird   = projectFinanceRows[item]
              }
            }else{
              this.finance = projectFinanceRows[item]
            }
          }
          //自定义属性
          if(projectAttrRows!=null && projectAttrRows.length>0){
                  this.collectAddress = projectAttrRows;
          }
          //图片信息
          if(projectPictureRows!=null && projectPictureRows.length>0){
                  this.projectPictureRows = projectPictureRows;
          }
          //附件信息
          if(projectAttachmentRows!=null && projectAttachmentRows.length>0){
                  this.projectAttachmentRows = projectAttachmentRows;
          }
        }else{
          this.dataList = [];
         
        }
      });
},addCollection:function(){
    protocol.param_addCollection.data.collectionId=this.$route.query.detailId; ;      
    protocol.param_addCollection.data.type = '1';
    http.posts(protocol.param_addCollection,protocol.param_addCollection.data).then(response => {
         let {msg,code} = response.data;
         if(code=='401'){
            //this.$message({ type: "warning", message: "还未登录，请先登录" });
            //alert("还未登录，请先登录");
            this.$Message.info("还未登录，请先登录");
            this.$router.push({path:'/load'});
          }else if(code==0){
            this.$Message.info(msg);
          }else{
            this.icon=2;
            this.$Message.info(msg);
          }
      });
}
    /*   getProduct () {

          setTimeout(() => {
            this.dataList = this.dataList.find(item => item.id === this.id);
          }, 0);
        }, */

      /*   init() {
          this.$http.get('/api/good').then((response) => {
            response = response.body;
            const ERR_OK = 0;
            if(response.errno === ERR_OK) {
              this.dataList = response.data;
            }
          });
        } */
      }

    }
</script>

<style scoped>
 td{
    border: 1px solid lightgray;
    height: 50px;
    font-size: 14px;
  }
  tr{ border: 1px solid lightgray}
  tr:hover{
    background: whitesmoke;
  }
  td:nth-child(2n-1){
    background:#F5F5F5;
    width:240px;

  }
  td:nth-child(2n){
    text-align: left;
     width:240px;
  }


  table{border-collapse: collapse;
    cursor: pointer;
    padding: 5%;
   
  }
    .info{
      line-height:110px; 
      font-size:15px;
       cursor: pointer;
    }
    .info:hover{
      color: orange
     
    }
</style>



// WEBPACK FOOTER //
// src/views/detail/detail1.vue